import { FIELD_TYPE } from '@/constants'

const categories = [
  { name: 'mnIdentity', base: {} },
  { name: 'currentEmployed', base: {} },
  { name: 'currentUnEmployed', base: {} },
  { name: 'govtAssistance', base: {} },
  { name: 'approvalLetter', base: {} },
  { name: 'denialLetter', base: {} }  
]

export function generateDocumentField(categoryName) {
  return {
    vHtmlLabel() {
      const config = this.getSupportDocCategoryConfig(categoryName)
      return config && config.label
    },
    vHtmlDescription() {
      const config = this.getSupportDocCategoryConfig(categoryName)
      return config && config.description
    },
    category: categoryName,
    apiKey: `supportingDocuments.${categoryName}.includeFiles`,
    fields: [
      {
        apiKey: `supportingDocuments.${categoryName}.files`,
        label: 'Upload File(s)',
        required(application) {
          return (
            application.supportingDocuments[categoryName].includeFiles &&
            'Please upload files under this category or uncheck the checkbox.'
          )
        },
        accept() {
          const config = this.getSupportDocCategoryConfig(categoryName)
          return config && config.supportedMIMETypes
        },
        category: categoryName,
        sizeLimitMB() {
          const config = this.getSupportDocCategoryConfig(categoryName)
          return config && config.sizeLimitMB
        },
        fileLimit() {
          const config = this.getSupportDocCategoryConfig(categoryName)
          return config && config.fileLimit
        },
        vHtmlDescription() {
          const config = this.getSupportDocCategoryConfig(categoryName)
          return (
            config &&
            config.helpText &&
            `<span class="grey--text text--lighten-2">${config.helpText}<span>`
          )
        },
        placeholder: 'Attach files',
        type: FIELD_TYPE.DOCUMENTS
      }
    ]
  }
}

export default [
  {
    label: 'Proof of Income',
    vHtmlDescription:
      '<p>Please upload documents for all of the following that apply to you.</p>',
    type: FIELD_TYPE.HEADING
  },
  {
    type: FIELD_TYPE.PANELS,
    panels: categories.map(category => ({
      ...category.base,
      ...generateDocumentField(category.name)
    }))
  }
]
